import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, ViewChildren, ComponentFactoryResolver, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import {
  FileRestrictions,
  SelectEvent,
  RemoveEvent,
  ErrorEvent,
  CancelEvent,
  PauseEvent,
  ResumeEvent,
  SuccessEvent,
  UploadEvent,
  UploadProgressEvent,
  ChunkSettings,
  FileInfo,
} from "@progress/kendo-angular-upload";
import { FormBuilderControl } from '@common/formbuilder/FormBuilderControl';
import { MfFormControlComponent } from '../mf-form-control.component';
@Component({
  selector: 'app-mfcustom-upload',
  templateUrl: './mfcustom-upload.component.html',
  styleUrls: ['./mfcustom-upload.component.css']
})
export class MfcustomUploadComponent implements OnInit {
  @Input() parent: MfFormControlComponent;
  @Input() formField: FormBuilderControl;
  constructor() { }

  get maxLimitReached() {
    if (this.formField && this.formField.fieldOptions && this.formField.fieldOptions.maxLength && this.parent.data && this.parent.data.length >= this.formField.fieldOptions.maxLength)
      return true;
    return false
  }

  ngOnInit() {
    if (this.parent && this.parent.parent && this.parent.parent.parent && this.parent.parent.parent.form) {
      if (!this.parent.parent.parent.form.skipUnflattenProperties) {
        this.parent.parent.parent.form.skipUnflattenProperties = new Array();
      }
        this.parent.parent.parent.form.skipUnflattenProperties.push(this.formField.field)
    }
  }

  successEventHandler(e: any) {
    e.files[0].fileCabinetDocumentId = e.response.body;
    e.files[0].fileCabinetId = e.response.body;
  }

  selectEventHandler(e: any) {
    if (this.parent.fieldDisabled)
      return e.preventDefault();
    if (this.maxLimitReached) {
      this.parent.messageService.error('Max file count limit reached')
      return e.preventDefault();
    }
  }
  removeEventHandler(e: any) {
    
    if (this.parent.fieldDisabled)
      return e.preventDefault();
    
    var filt = this.parent.data.filter((o) => e.files[0].fileCabinetDocumentId == o.fileCabinetDocumentId);
    if (filt.length > 0) {
      this.parent.data.splice(this.parent.data.indexOf(filt[0]), 1);
      this.parent.dataChange.emit(this.parent.data);     
    }
    this.parent.triggerDirty(null, null);
    //e.preventDefault();
  }
  uploadEventHandler(e: any) {
    if (this.parent.fieldDisabled)
      return e.preventDefault();
    if (this.maxLimitReached) {
      this.parent.messageService.error('Max file count limit reached')
      return e.preventDefault();
    }
    this.parent.formField.blockSaving = true;
  }
  completeEventHandler(e: any) {
    this.parent.formField.blockSaving = false;
    this.parent.triggerDirty(null, null);
  }

  downloadFile(file) {
    this.parent.loading = true;
    let endPoint: string = this.formField.fieldOptions.dataEndPoint.url + file.fileCabinetDocumentId;
    this.parent.apiService.downloadFile(endPoint)
      .subscribe(respData => {
        var blob = new Blob([respData]);
        this.parent.apiService.saveFile(blob, file.name);
        this.parent.loading = false;
        this.parent.cdr.detectChanges();
      }, error => {
        this.parent.loading = false;
        this.parent.cdr.detectChanges();
        console.log('err');
      });

  }

  public error(e: ErrorEvent): void {
    this.parent.messageService.error('Please click on the retry button', 'Failed to upload file')
  }
}
